import React from 'react';
import { Box, Typography } from '@mui/material';
import { Milestone, StepItem, StepItemIcon, StepStatus } from 'domain/shared/timeline';

interface MilestoneItemProps {
  milestone: Milestone;
}

const MilestoneItem: React.FC<MilestoneItemProps> = ({ milestone }) => {
  return (
    <React.Fragment key={milestone.milestoneName}>
      <StepItem>
        <Box display="flex" alignItems="flex-start" flexDirection="column">
          <StepItemIcon status={milestone.status} />
          <Typography align="left" variant={milestone.status === StepStatus.ACTIVE ? 'subtitle2' : 'body2'}>
            {milestone.milestoneName}
          </Typography>
        </Box>
      </StepItem>
    </React.Fragment>
  );
};

export default MilestoneItem;
